export const HelpParseKeyValueString = (input) => {
  // Dividir la cadena en partes usando '|' como delimitador
  const pairs = input.split("|");

  // Crear un objeto para almacenar los pares clave-valor
  const result = {};

  // Iterar sobre cada par clave-valor
  pairs.forEach((pair) => {
    // Dividir cada par en clave y valor usando '=' como delimitador
    const [key, value] = pair.split("=");

    // Asignar el valor a la clave correspondiente en el objeto resultante
    result[key] = value;
  });

  // Retornar el objeto con los pares clave-valor
  return result;
};
export const HelpParseKeyValueString2 = (input) => {
  // Eliminar el ? inicial si existe
  const cleanInput = input.startsWith('?') ? input.substring(1) : input;
  
  const pairs = cleanInput.split('&');
  const result = {};
  
  pairs.forEach((pair) => {
    // Dividir solo en el primer = para manejar valores que contengan =
    const index = pair.indexOf('=');
    if (index === -1) {
      // Si no hay =, guardar la clave con valor vacío
      result[pair] = '';
    } else {
      const key = pair.substring(0, index);
      const value = pair.substring(index + 1);
      result[key] = value || '';
    }
  });
  
  return result;
};

export const HelpParseKeyValueStringIdClaro = (input) => {
  const pairs = input.split('|');
  const result = {};

  pairs.forEach(pair => {
    const [key, ...rest] = pair.split('=');
    result[key] = rest.join('=');  // Join the rest to handle '=' in values
  });

  return result;
};

export const cleanObj = (obj) => Object.fromEntries(
  Object.entries(obj).filter(([_, v]) => v != null && v !== "")
);
